




































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import DateForm from '@/components/misc/DateForm.vue'
import { ITransactionParams } from '@/services/transactions'

@Component({
    components: {
        DateForm,
    },
})
export default class TxParams extends Vue {
    startDate: string = new Date().toISOString()
    endDate: string = new Date().toISOString()
    sort = 'timestamp-desc'
    sorts = [
        {
            label: 'New to Old',
            query: 'timestamp-desc',
        },
        {
            label: 'Old to New',
            query: 'timestamp-asc',
        },
    ]
    limit = 25
    limits = [10, 25, 100, 1000, 5000]

    setStart(val: string) {
        this.startDate = val
    }

    setEnd(val: string) {
        this.endDate = val
    }

    submit() {
        let params: ITransactionParams = {
            sort: this.sort,
            limit: this.limit,
        }

        params =
            this.sort === 'timestamp-desc'
                ? {
                      endTime: Math.round(
                          new Date(this.endDate).getTime() / 1000
                      ),
                      ...params,
                  }
                : {
                      startTime: Math.round(
                          new Date(this.startDate).getTime() / 1000
                      ),
                      ...params,
                  }

        this.$emit('change', params)
    }
}
